import React from "react";
import { t } from "i18next";
import moment from "moment";
import {
  Approved,
  Pending,
  Submitted
} from "common/status";
import withDataTable from "common/components/withDataTable";
import { Util } from "common/util";
import { 
  InputRangeDate,
  Statistic,
  Card,
  Row,
  Col
 } from "common/elements";
import { getMany, getSummary } from "services/attendance";
import EmployeeProfile from "common/components/EmployeeProfile";

const pathName = "timesheets";
const columns = [
  {
    title: t("text_employee_name"),
    dataIndex: "name",
    key: "index",
    render: (name, record) => {
      return (
        <EmployeeProfile photo={record.photo} employeeName={record.name} />
      );
    },
  },
  {
    title: t("text_position"),
    dataIndex: "position",
    key: "position",
    render: position => position
  },
  {
    title: t("text_status"),
    dataIndex: "status",
    key: "status",
    render: status => {
      if (status === "PENDING") return <Pending />;
      if (status === "SUBMITTED") return <Submitted />;
      if (status === "APPROVED") return <Approved />;
    }
  },
  {
    title: t("text_date"),
    dataIndex: "month",
    key: "month",
    render: (month, record) => moment(`${record.year}/${month && month.toString().padStart(2, "0")}/01`).format("MMMM YYYY")
  },
  {
    title: t("text_submitted_date"),
    dataIndex: "submittedDate",
    key: "submittedDate",
    render: submittedDate => submittedDate ? moment(submittedDate).format("ddd DD MMM, YYYY") : ""
  },
  {
    title: t("text_approver"),
    dataIndex: "approver",
    key: "approver",
    render: approver => approver
  },
  {
    title: t("text_approved_date"),
    dataIndex: "approvedDate",
    key: "approvedDate",
    render: approvedDate => approvedDate ? moment(approvedDate).format("ddd DD MMM, YYYY") : ""
  }
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  let filter = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = parseInt(params.get("size"));
  }

  if (params.get("current")) {
    current = parseInt(params.get("current"));
  }

  option["limit"] = parseInt(limit);
  option["offset"] = (current - 1) * limit;

  if (Object.keys(filter).length) {
    option["filter"] = JSON.stringify(filter);
  }

  if (searchStr) {
    option["search"] = searchStr;
  }

  if (params.get("status")) {
    option["status"] = [params.get("status")];
  }

  if (params.get("dates")) {
    const rangeDates = params.get("dates").split(",");
    option["rangFilter"] = JSON.stringify({
      value: rangeDates,
    });
  }

  return getMany(option);
};

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);
  let searchStr = `search=${value}`;

  if (params.get("dates")) {
    searchStr += `&dates=${params.get("dates")}`;
  }

  Util.getInstance().pushParamsToURL(pathName, searchStr);
};

const onChangeDate = (value) => {
  const params = new URLSearchParams(document.location.search);
  let symbol = "";
  if (value) {
    let valueDate = `${symbol}${moment(value[0]).format(
      "YYYY-MM-DD"
    )}${","}${moment(value[1]).format("YYYY-MM-DD")}`;
    params.set("dates", valueDate);
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  } else {
    params.delete("dates");
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  }
};

const filterFields = () => {
  return (
    <div id="date-range">
      <InputRangeDate
        name="dates"
        label={t("text_date_range")}
        placeholder={[t("text_dd_mm_yyyy"), t("text_dd_mm_yyyy")]}
        format="DD/MM/YYYY"
        onChange={onChangeDate}
        style={{
          width: "335px",
          height: "32px",
        }}
        separator={"~"}
      />
    </div>
  );
};

function TimesheetStatistic() {
  const [summary, setSummary] = React.useState({pending: 0, submitted: 0, approved: 0});

  React.useEffect(() => {
    getSummary()
    .then(response => {
      setSummary(response);
    });
  }, []);
  
  return <Row gutter={16}>
    <Col lg={8}>
      <Card>
        <Statistic
          title="Pending"
          value={summary.pending} 
        />
      </Card>
    </Col>
    <Col lg={8}>
      <Card>
        <Statistic
          title="Submitted"
          value={summary.submitted}
        />
      </Card>
    </Col>
    <Col lg={8}>
      <Card>
        <Statistic
          title="Approved"
          value={summary.approved}
        />
      </Card>
    </Col>
  </Row>;
}

export default withDataTable({
  title: t("text_timesheet"),
  addViewLink: "/timesheets/detail",
  topFilterItems: [],
  showFilter: true,
  showPagination: true,
  showAddNew: false,
  showButtonInfo: true,
  showButtonDelete: false,
  showButtonUpdate: false,
  showStatistic: true,
  columns,
  pathName,
  defaultCurrent,
  defaultPageSize,
  permission: "timesheet",
  fileStatistic: TimesheetStatistic,
  filterFields,
  handleSearch,
  getData,
  handleShowDetail: (attendanceEntryId, reviewRef) => reviewRef.showDrawer(attendanceEntryId),
});
